import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom'
import 'react-loading-skeleton/dist/skeleton.css'


const Products = () => {

    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(data);
    const [loading, setLoading] = useState(false);





    let componentMounted = true;

    useEffect(() => {
        const getProducts = async () => {
            setLoading(true);
            const response = await fetch("https://fakestoreapi.com/products");
            if (componentMounted) {
                setData(await response.clone().json());
                setFilter(await response.json());
                setLoading(false);
                console.log(filter);
            }
            return () => {
                componentMounted = false;
            }
        }
        getProducts();

    }, []);
    const Loading = () => {
        return (
            <>

                <div class="main">
                    <div id="firstDot"></div>
                    <div id="secondDot"></div>
                    <div id="thirdDot"></div>
                    <div id="fourthDot"></div>
                </div>
            </>

        );

    };


    const filterProduct = (cat) => {
        const updatedList = data.filter((x) => x.category === cat);
        setFilter(updatedList);
    }



    const ShowProducts = () => {






        return (

            <>



                <div>
                    <li className="buttons mb-2">
                        <a class="btn btn-outline-dark fw-bolder dropdown-toggle" id="navbarDropdownMenuLink" data-bs-toggle="dropdown" >
                            Product
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                            <li><button class="dropdown-item" onClick={() => setFilter(data)}>All</button></li>
                            <li><button class="dropdown-item" onClick={() => filterProduct("men's clothing")}>Men's Cloating</button></li>
                            <li><button class="dropdown-item" onClick={() => filterProduct("women's clothing")}>Women's Cloating</button></li>
                            <li><button class="dropdown-item" onClick={() => filterProduct("jewelery")}>Jewelery Cloating</button></li>
                            <li><button class="dropdown-item" onClick={() => filterProduct("electronics")}>Electronic</button></li>
                        </ul>
                    </li>

                </div>








                {
                    filter.map((product) => {
                        return (
                            <>
                                <div className="card--color col-md-3 mb-4">
                                    <div class="card card-colorr h-100 text-center p-4 " key={product.id}>
                                        <img src={product.image} class="card-img-top card--color" alt={product.title} height="250px"></img>
                                        <div class="card-body">
                                            <h5 class="card-title text-dark mb-0">{product.title.substring(0, 12)}
                                            </h5>
                                            <p class="card-text text-dark lead fw-bold">${product.price}
                                            </p>
                                            <NavLink to={`/products/${product.id}`} class="btn btn-outline-dark buttonnn">
                                                Buy Now
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )

                    })
                }

            </>
        );
    };





    return (

        <div>
            <div className="halaman container my-5 py-5" >
                <div className="row">
                    <div className="product--title col-12 mb-1">
                        <h1 className="display-6 fw-bolder text-white text-center" >Latest Products</h1>
                        <hr className="bg-dark" />
                    </div>
                </div>
                <div className="row justify-content-center">
                    {loading ? <Loading /> : <ShowProducts />}
                </div>
            </div>

        </div>
    );

}



export default Products;
